/**
 * Tema LDS (Localiza Design System) do Irondome.
 *
 * O tema padrão do LDS (`defaultTheme`) já é a identidade Localiza (verde),
 * portanto usamos `createTheme({})` sem overrides — os tokens
 * `var(--lds-color-*)`, `var(--lds-spacing-*)`, etc. resolvem para a paleta
 * Localiza automaticamente.
 *
 * Aplicado em runtime via `AppTheme.apply(theme)` no bootstrap (main.tsx),
 * conforme a instrução oficial `setup-lds-theme` para React SPA.
 *
 * Requisitos: 14.1 (identidade visual), 14.7 (contraste WCAG — validado pelo
 * teste Python tests/pbt/test_irondome_wcag_properties.py sobre a paleta).
 */

import { createTheme, type Theme } from '@lds/themes';

export const theme: Theme = createTheme({});
